.SelectItem {
}
.SelectItem:hover {
  outline: none;
  background-color: #f1f1f1;
}

.SelectItem[data-highlighted] {
  outline: none;
  background-color: #f1f1f1;
}

.Trigger {
  background-color: #fff;
  transition: 0.15s background-color;
}
.Trigger:hover {
  background-color: #f1f1f1;
}
